import React, { memo } from 'react'
import { View, StyleSheet } from 'react-native'
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookMessengerIcon,
  FacebookMessengerShareButton,
  FacebookShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon
} from 'react-share'

import { DS } from '@/design-system'

const ICON_SIZE = 40

interface SocialIconsProps {
  title: string
  shareUrl: string
}

export const SocialIcons = memo(({ title, shareUrl }: SocialIconsProps) => {
  return (
    <DS.Frame row style={styles.container}>
      <View style={styles.iconContainer}>
        <WhatsappShareButton title={title} separator=" " url={shareUrl}>
          <WhatsappIcon size={ICON_SIZE} round />
        </WhatsappShareButton>
      </View>

      <View style={styles.iconContainer}>
        <FacebookShareButton url={shareUrl}>
          <FacebookIcon size={ICON_SIZE} round />
        </FacebookShareButton>
      </View>

      <View style={styles.iconContainer}>
        <TwitterShareButton url={shareUrl} title={title}>
          <XIcon size={ICON_SIZE} round />
        </TwitterShareButton>
      </View>

      <View style={styles.iconContainer}>
        <TelegramShareButton url={shareUrl} title={title}>
          <TelegramIcon size={ICON_SIZE} round />
        </TelegramShareButton>
      </View>

      <View style={styles.iconContainer}>
        <EmailShareButton url={shareUrl} subject={title} body={`${title}\n\n${shareUrl}`}>
          <EmailIcon size={ICON_SIZE} round />
        </EmailShareButton>
      </View>

      <View style={styles.iconContainer}>
        <FacebookMessengerShareButton url={shareUrl} appId="521270401588372">
          <FacebookMessengerIcon size={ICON_SIZE} round />
        </FacebookMessengerShareButton>
      </View>
    </DS.Frame>
  )
})

SocialIcons.displayName = 'SocialIcons'

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    gap: 12
  },
  iconContainer: {
    alignItems: 'center',
    justifyContent: 'center'
  }
})
